<template>
  <div class="page">
    <PageHeader>
<!--      <div slot="left">-->
<!--        &lt;!&ndash;<router-link-->
<!--          class="text-decoration-none"-->
<!--          :to="{ name: 'member-add', params: { groupName: selectedGroup } }"-->
<!--        >-->
<!--          <v-btn text>-->
<!--            <v-icon class="mr-2">mdi-plus-circle-outline</v-icon> {{ $t('New citizen') }}-->
<!--          </v-btn>-->
<!--        </router-link>&ndash;&gt;-->
<!--        <table class="styled-table">-->
<!--          <thead>-->
<!--          <tr>-->
<!--            <th>Id</th>-->
<!--            <th>Battery</th>-->
<!--            <th>IsPlugged</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr-->
<!--            v-for="(device, index) in devices"-->
<!--            :key="index"-->
<!--          >-->
<!--            <td>{{device.deviceId}}</td>-->
<!--            <td>{{device.battery}}</td>-->
<!--            <td>{{device.isPlugged}}</td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->
    </PageHeader>
    <div class="px-8 pb-8">
      <div class="d-lg-inline">
        <div class="members-title">
          <div class="align-lg-end col-lg-2 col-md-2">
            <v-select v-model="selectedSort" :items="sortOptions" :label="$t('Sort')" item-text="text" item-value="value" @change="changeSort" />
          </div>
          <div>{{ $t('Your active citizens') }}</div>
        </div>
      </div>
      <div v-if="loading" class="loading-container">
        <KlikkitLogoLoader style="height: 250px; width: 250px; opacity: 0.2" />
      </div>
      <div class="members-list">
        <router-link
          v-for="(member, index) in activeMembers"
          :to="{ name: 'member-show', params: { userId: member.id } }"
          :key="index"
          class="members-item"
        >
          <v-card v-if="!loading" class="members-card">
            <div class="members-card-name">{{ member.fullName }}
              <v-icon :style="batteryIconStyle(member.id)" class="battery-icon">{{ showUserDeviceStatus(member.id) }}</v-icon>
            </div>
            <div
              class="members-card-alerts"
              :class="member.deviations && member.deviations.deviations ? 'members-card-alerts-red'
            : 'members-card-alerts-green'"
            >{{ member.deviations ? member.deviations.deviations : 0 }}</div>
          </v-card>

        </router-link>
      </div>
      <div class="members-title">{{ $t('Your inactive citizens') }}</div>
      <div v-if="loading" class="loading-container">
        <KlikkitLogoLoader style="height: 250px; width: 250px; opacity: 0.2" />
      </div>
      <div class="members-list">
        <router-link
          v-for="(member, index) in inactiveMembers"
          :to="{ name: 'member-show', params: { userId: member.id } }"
          :key="index"
          class="members-item"
        >
          <v-card v-if="!loading" class="members-card">
            <div class="members-card-name">{{ member.fullName }}</div>
            <div
              class="members-card-alerts"
              :class="member.deviations && member.deviations.deviations ? 'members-card-alerts-red'
            : 'members-card-alerts-green'"
            >{{ member.deviations ? member.deviations.deviations : 0 }}</div>
          </v-card>

        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import PageHeader from '@/globals/components/PageHeader.vue';
import KlikkitLogoLoader from '../../modules/svg/KlikkitLogoLoader.vue';

export default {
  name: 'member-list',
  components: {
    PageHeader,
    KlikkitLogoLoader,
  },
  data() {
    return {
      loading: true,
      selectedSort: 'deviations',
    };
  },
  computed: {
    selectedGroup() {
      return this.$store.state.selectedGroup;
    },
    sortOptions() {
      return [
        { text: this.$t('Sort by deviations'), value: 'deviations' },
        { text: this.$t('Sort by name'), value: 'name' },
      ];
    },
    activeMembers() {
      if (!this.loading) {
        return this.$Member.query().with('deviations').get()
          .filter((a) => a.taskCount > 0)
          .sort((a, b) => {
            if (this.selectedSort === 'name') {
              return a.fullName.localeCompare(b.fullName);
            }
            if (!a.deviations) return 1;
            if (!b.deviations) return -1;
            if (a.deviations.deviations < (b.deviations.deviations)) {
              return 1;
            }
            return -1;
          });
      }
      return [];
    },
    inactiveMembers() {
      if (!this.loading) {
        return this.$Member.query().with('deviations').get()
          .filter((a) => a.taskCount === 0)
          .sort((a, b) => {
            if (this.selectedSort === 'name') {
              return a.fullName.localeCompare(b.fullName);
            }
            if (!a.deviations) return 1;
            if (!b.deviations) return -1;
            if (a.deviations.deviations < (b.deviations.deviations)) {
              return 1;
            }
            return -1;
          });
      }
      return [];
    },
    devices() {
      if (!this.loading) {
        return this.$Device.query().get();
      }
      return [];
    },
  },
  created() {
    const preferredSort = localStorage.getItem('preferredSort');
    if (preferredSort) {
      this.selectedSort = preferredSort;
    }
    this.loading = true;
    Promise.all([
      this.$Member.api().fetchByGroupName(this.$store.state.selectedGroup),
      this.$MemberDeviation.api().fetchByGroupName(this.$store.state.selectedGroup),
      this.$Device.api().fetchByGroupName(this.$store.state.selectedGroup),
    ]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    changeSort(event) {
      localStorage.setItem('preferredSort', event);
    },
    showUserDeviceStatus(userId) {
      const sortedDevices = this.devices.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      const d = sortedDevices.find((device) => device.user === userId);
      if (!d) {
        return '';
      }

      let batteryString = 'mdi-battery';
      if (d.isPlugged) {
        batteryString += '-charging';
      }

      if (d.battery >= 100) {
        return batteryString;
      }

      let batteryLevel = Math.floor(d.battery / 10);
      if (batteryLevel === 0) {
        batteryLevel = 1;
      }

      batteryString += `-${batteryLevel * 10}`;

      return batteryString;
    },
    batteryIconStyle(userId) {
      const sortedDevices = this.devices.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      const d = sortedDevices.find((device) => device.user === userId);
      if (!d) {
        return { };
      }

      if (d.isPlugged) {
        return {
          color: '#0dac30',
        };
      }

      if (!d.isPlugged && d.battery <= 20) {
        return {
          color: '#ff454b',
        };
      }

      return {
        color: '#242e4c',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.styled-table {
  width: 100%;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: sans-serif;
  text-align: left;
  border-collapse: collapse;
}
.styled-table thead tr {
  background-color: #009879;
  color: #ffffff;
  text-align: left;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #009879;
}
  .page {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .members-title {
    font-size: 18px;
    font-weight: bold;
    color: #707070;
    padding: 12px 6px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 26px;
  }

  .members-list {
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
  }

  @keyframes slideIn {
    0% {
      opacity: 0;
      margin-left: -30px;
    }
    100% {
      opacity: 1;
      margin-left: 0;
    }
  }

  .members-item {
    margin-bottom: 10px;
    text-decoration: none;
    animation: slideIn .2s linear forwards;
  }

  .members-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 16px;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }

    &-name {
      font-weight: bold;
      color: #242E4C;
    }

    @keyframes grow {
      0% {
        transform: scale(0);
      }
      40% {
        transform: scale(0);
      }
      80% {
        transform: scale(1.3);
      }
      100% {
        transform: scale(1);
      }
    }

    &-alerts {
      height: 36px;
      width: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 50% !important;
      animation: grow 0.5s linear forwards;
    }

    &-alerts-red {
      background-color: #FF454B;
    }

    &-alerts-green {
      background-color: #0dac30;
    }
  }

</style>
